import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-call-center-details',
  templateUrl: './call-center-details.component.html',
  styleUrls: ['./call-center-details.component.scss']
})
export class CallCenterDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
